"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3343],{

/***/ 49770:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "XM": function() { return /* binding */ RECRUIT_LOGO_IMAGE_SIZE; },
/* harmony export */   "nF": function() { return /* binding */ LINKAREER_MAGAZINE_WIDTH_SIZE; },
/* harmony export */   "rE": function() { return /* binding */ LINKAREER_MAGAZINE_IMAGE_RENDER_WIDTH; },
/* harmony export */   "sF": function() { return /* binding */ LINKAREER_MAGAZINE_IMAGE_RENDER_HEIGHT; },
/* harmony export */   "w8": function() { return /* binding */ LINKAREER_MAGAZINE_HEIGHT_SIZE; }
/* harmony export */ });
var RECRUIT_LOGO_IMAGE_SIZE = 60;
var LINKAREER_MAGAZINE_WIDTH_SIZE = 140;
var LINKAREER_MAGAZINE_HEIGHT_SIZE = 70;
var LINKAREER_MAGAZINE_IMAGE_RENDER_WIDTH = 140;
var LINKAREER_MAGAZINE_IMAGE_RENDER_HEIGHT = 76;


/***/ }),

/***/ 23343:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_Box__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(28889);
/* harmony import */ var _material_ui_core_CircularProgress__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(95477);
/* harmony import */ var _material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(17812);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(86010);
/* harmony import */ var date_fns_format__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(32912);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44119);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(graphql_tag__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lodash_take__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69572);
/* harmony import */ var lodash_take__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_take__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(30132);
/* harmony import */ var generated_graphql__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47079);
/* harmony import */ var _app_components_Skeleton__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96679);
/* harmony import */ var _app_modules_hooks_useIsWebview__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(67235);
/* harmony import */ var _app_modules_util__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(65677);
/* harmony import */ var app_constants_recruitImageSize__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(49770);
/* harmony import */ var components_ActivityScrap__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(91202);
/* harmony import */ var components_Link__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(34557);
/* harmony import */ var components_OldChip__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(53518);
/* harmony import */ var constants_enums__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(35460);
/* harmony import */ var constants_typeText__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(25536);
/* harmony import */ var hooks_useKeywordHighlighter__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(17683);
/* harmony import */ var svgIcons_BookMark__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(49123);
/* harmony import */ var utils_optimizeImageUrl__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(65342);
/* harmony import */ var utils_utils__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(55208);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment ActivityListItem_currentUser on User {\n    ...ActivityScrap_currentUser\n  }\n  fragment ActivityListItem_activity on Activity {\n    id\n    type\n    viewCount\n    activityEndAt\n    isScrapped\n    title\n    jobTypes\n    recruitInformations {\n      id\n      jobType\n      internTypes {\n        id\n        name\n      }\n    }\n    recruitType\n    recruitScale\n    organizationName\n    recruitCloseAt\n    viewCount\n    thumbnailImage {\n      id\n      url\n    }\n    logoImage {\n      id\n      url\n    }\n    categories {\n      id\n      name\n    }\n    regions {\n      id\n      name\n    }\n    regionDistricts {\n      id\n      name\n      region {\n        id\n        name\n      }\n    }\n    ...ActivityScrap_activity\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: 100%;\n    background-color: #ffffff;\n    padding: 15px 10px 15px 20px;\n    display: flex;\n    align-items: center;\n\n    ",
        " {\n      padding-left: 0;\n    }\n\n    &.large {\n      padding-top: 20px;\n      padding-bottom: 20px;\n\n      ",
        " {\n        padding-top: 15px;\n        padding-bottom: 15px;\n      }\n    }\n\n    .company-name {\n      font-size: 12px;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      text-align: left;\n      font-weight: 500;\n      height: 18px;\n      line-height: 18px;\n    }\n\n    .title {\n      font-size: 16px;\n      white-space: pre-wrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      height: 19px;\n      line-height: 19px;\n      text-align: left;\n      display: -webkit-box;\n      -webkit-line-clamp: 1;\n      -webkit-box-orient: vertical;\n      font-weight: 500;\n\n      & .highlight {\n        font-weight: 600;\n      }\n    }\n\n    .link {\n      &:hover {\n        text-decoration: underline;\n      }\n    }\n\n    .dot {\n      font-size: 12px;\n      font-weight: 300;\n      margin-left: 5px;\n      margin-right: 5px;\n    }\n\n    .category {\n      font-size: 12px;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      text-align: left;\n      font-weight: 400;\n      padding-right: 10px;\n    }\n\n    .short-info-typo {\n      font-size: 12px;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      text-align: left;\n      font-weight: 400;\n      padding-right: 10px;\n      height: 18px;\n      line-height: 18px;\n    }\n\n    .view-count {\n      margin-left: 0;\n    }\n\n    .button-scrap {\n      color: ",
        ";\n      padding-bottom: 5px;\n\n      @media (hover: hover) and (pointer: fine) {\n        &:hover {\n          color: ",
        ";\n        }\n      }\n    }\n\n    .scrap-count {\n      color: ",
        ";\n      font-size: 12px;\n      font-weight: 500;\n      height: 18px;\n      line-height: 18px;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      text-align: center;\n    }\n\n    .scrap-count-skeleton {\n      margin: auto;\n    }\n\n    .scrapped {\n      path {\n        fill: ",
        ";\n      }\n    }\n\n    .icon-bookmark {\n      width: 15px;\n      height: 15px;\n      color: #666666;\n    }\n\n    .img-thumbnail {\n      border-radius: 5px;\n    }\n\n    .chip {\n      background-color: #bbbbbb;\n      border: 0;\n      border-radius: 3px;\n      margin-right: 5px;\n      height: auto;\n    }\n\n    .label-chip {\n      line-height: 1em;\n      font-size: 12px;\n      padding: 3px;\n      color: #ffffff;\n      font-weight: 500;\n    }\n\n    .hot {\n      background-color: #ef2929;\n    }\n\n    .recommend-tag-container {\n      display: flex;\n      padding: 2px;\n      border: 1px solid ",
        ";\n      border-radius: 3px;\n      margin-right: 5px;\n      flex-shrink: 0;\n    }\n\n    .recommend-text {\n      color: ",
        ";\n      font-size: 11px;\n    }\n\n    .container {\n      display: flex;\n    }\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


























graphql_tag__WEBPACK_IMPORTED_MODULE_2___default()(_templateObject());
var ActivityListItem = function(props) {
    var renderSecondary = function renderSecondary() {
        if (isRecruit) {
            var ref;
            var categoriesText = "-";
            if (categories.length > 1) {
                categoriesText = "각 부문";
            } else if (categories.length === 1 && categories[0]) {
                categoriesText = categories[0];
            }
            var _obj;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                display: "flex",
                alignItems: "center",
                maxWidth: "100%",
                flexShrink: 0,
                flexWrap: "wrap",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                        display: "flex",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                mr: 0,
                                children: isLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_app_components_Skeleton__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                    height: 13
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                    className: "short-info-typo",
                                    children: (activity === null || activity === void 0 ? void 0 : (ref = activity.jobTypes) === null || ref === void 0 ? void 0 : ref.length) ? (0,utils_utils__WEBPACK_IMPORTED_MODULE_18__/* .getJobType */ .ob)(lodash_take__WEBPACK_IMPORTED_MODULE_4___default()(activity.jobTypes, 2)) : "-"
                                })
                            }),
                            isLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_app_components_Skeleton__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                width: 100,
                                height: 13
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                flexGrow: 1,
                                display: "flex",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                    className: "category",
                                    children: categoriesText
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                        display: "flex",
                        children: [
                            isLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_app_components_Skeleton__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                height: 13
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                className: "short-info-typo",
                                children: (activity === null || activity === void 0 ? void 0 : activity.recruitType) ? (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(_obj, generated_graphql__WEBPACK_IMPORTED_MODULE_7__/* .ActivityRecruitType.NORMAL */ .iS2.NORMAL, (activity === null || activity === void 0 ? void 0 : activity.recruitCloseAt) ? "~ ".concat((0,date_fns_format__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(new Date(activity.recruitCloseAt), "MM.dd")) : "-"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(_obj, generated_graphql__WEBPACK_IMPORTED_MODULE_7__/* .ActivityRecruitType.ALWAYS */ .iS2.ALWAYS, "상시채용"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(_obj, generated_graphql__WEBPACK_IMPORTED_MODULE_7__/* .ActivityRecruitType.ASAP */ .iS2.ASAP, "채용 시 마감"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(_obj, generated_graphql__WEBPACK_IMPORTED_MODULE_7__/* .ActivityRecruitType.SCHEDULED */ .iS2.SCHEDULED, "예정"), _obj)[activity.recruitType] : "-"
                            }),
                            isLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_app_components_Skeleton__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                height: 13
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                className: "short-info-typo",
                                children: [
                                    "조회 ",
                                    viewCount
                                ]
                            })
                        ]
                    })
                ]
            });
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
            display: "flex",
            alignItems: "center",
            maxWidth: "100%",
            flexShrink: 0,
            children: isLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                        mr: 1,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_app_components_Skeleton__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            width: 40,
                            height: 13
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_app_components_Skeleton__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        width: 40,
                        height: 13
                    })
                ]
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                        className: "short-info-typo",
                        children: (activity === null || activity === void 0 ? void 0 : activity.recruitCloseAt) ? (0,date_fns_format__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(activity.recruitCloseAt, "~M.dd") : "-"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)("short-info-typo", "view-count"),
                        children: [
                            "조회 ",
                            viewCount
                        ]
                    })
                ]
            })
        });
    };
    var ref, ref1, ref2, ref3, ref4, ref5;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)();
    var isWebview = (0,_app_modules_hooks_useIsWebview__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)();
    var _className = props.className, className = _className === void 0 ? "" : _className, _size = props.size, size = _size === void 0 ? "medium" : _size, isLoading = props.isLoading, activity = props.activity, currentUser = props.currentUser, _showActivityType = props.showActivityType, showActivityType = _showActivityType === void 0 ? false : _showActivityType, _showHotIcon = props.showHotIcon, showHotIcon = _showHotIcon === void 0 ? false : _showHotIcon, _searchKeyword = props.searchKeyword, searchKeyword = _searchKeyword === void 0 ? "" : _searchKeyword, initScrapIcon = props.scrapIcon, _showScrapCount = props.showScrapCount, showScrapCount = _showScrapCount === void 0 ? true : _showScrapCount, scrapRefetchQueries = props.scrapRefetchQueries, linkProps = props.linkProps, itemTitle = props.itemTitle, isRecommend = props.isRecommend;
    var scrapIcon = initScrapIcon !== null && initScrapIcon !== void 0 ? initScrapIcon : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(svgIcons_BookMark__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
        className: "icon-bookmark",
        isOn: activity === null || activity === void 0 ? void 0 : activity.isScrapped,
        strokeType: "#666666"
    });
    var activityTypeText = lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(constants_typeText__WEBPACK_IMPORTED_MODULE_15__/* .ACTIVITY_TYPE_TEXT */ .DK, (activity === null || activity === void 0 ? void 0 : activity.type) || "", "");
    var isRecruit = (activity === null || activity === void 0 ? void 0 : activity.type) === constants_enums__WEBPACK_IMPORTED_MODULE_14__/* .ActivityTypeID.RECRUIT */ .kF.RECRUIT;
    var ref6;
    var categories = ((ref6 = activity === null || activity === void 0 ? void 0 : activity.categories) !== null && ref6 !== void 0 ? ref6 : []).map(function(category) {
        return category === null || category === void 0 ? void 0 : category.name;
    });
    var highlightedTitle = (0,hooks_useKeywordHighlighter__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({
        text: itemTitle || (activity === null || activity === void 0 ? void 0 : activity.title) || "",
        keyword: searchKeyword
    });
    var viewCount = (activity === null || activity === void 0 ? void 0 : activity.viewCount) || "0";
    if (typeof viewCount === "number" && viewCount > 9999) {
        viewCount = "999+";
    }
    var handleClickOrganization = function() {
        var ref;
        if (activity === null || activity === void 0 ? void 0 : (ref = activity.manager) === null || ref === void 0 ? void 0 : ref.channel) {
            router.push((0,_app_modules_util__WEBPACK_IMPORTED_MODULE_10__/* .getWebviewHref */ .ys)("/channel/".concat(activity.manager.channel.url), isWebview));
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)(className, {
            large: size === "large"
        }),
        "data-activityid": activity === null || activity === void 0 ? void 0 : activity.id,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                width: 60,
                mr: 1.875,
                flexShrink: 0,
                alignItems: "center",
                display: "flex",
                onClick: handleClickOrganization,
                children: isLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_app_components_Skeleton__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    width: 60,
                    height: 60
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_5___default()), {
                    loader: utils_optimizeImageUrl__WEBPACK_IMPORTED_MODULE_23__/* .imageLoader */ .X,
                    className: "img-thumbnail",
                    alt: (activity === null || activity === void 0 ? void 0 : activity.title) || "",
                    width: app_constants_recruitImageSize__WEBPACK_IMPORTED_MODULE_24__/* .RECRUIT_LOGO_IMAGE_SIZE */ .XM,
                    height: app_constants_recruitImageSize__WEBPACK_IMPORTED_MODULE_24__/* .RECRUIT_LOGO_IMAGE_SIZE */ .XM,
                    src: (0,utils_optimizeImageUrl__WEBPACK_IMPORTED_MODULE_23__/* .optimizeImageUrl */ .m)({
                        url: isRecruit ? (activity === null || activity === void 0 ? void 0 : (ref = activity.logoImage) === null || ref === void 0 ? void 0 : ref.url) || "" : (activity === null || activity === void 0 ? void 0 : (ref1 = activity.thumbnailImage) === null || ref1 === void 0 ? void 0 : ref1.url) || "",
                        width: app_constants_recruitImageSize__WEBPACK_IMPORTED_MODULE_24__/* .RECRUIT_LOGO_IMAGE_SIZE */ .XM,
                        height: "auto"
                    }),
                    objectFit: "contain"
                }, "live-activity-logo-image-".concat(activity === null || activity === void 0 ? void 0 : (ref2 = activity.logoImage) === null || ref2 === void 0 ? void 0 : ref2.id))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                flexGrow: 1,
                display: "flex",
                minWidth: 0,
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                        mr: 3.75,
                        flexGrow: 1,
                        display: "flex",
                        minWidth: 0,
                        maxWidth: "100%",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                mr: 3.75,
                                mb: 0.5,
                                width: "100%",
                                flexGrow: 0,
                                flexShrink: 0,
                                children: isLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_app_components_Skeleton__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                    width: 100,
                                    height: 13
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                    display: "flex",
                                    alignItems: "center",
                                    children: [
                                        showHotIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_OldChip__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)("chip", "hot"),
                                            classes: {
                                                label: "label-chip"
                                            },
                                            label: "HOT",
                                            color: "primary",
                                            size: "small"
                                        }),
                                        showActivityType && activityTypeText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_OldChip__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                            className: "chip",
                                            classes: {
                                                label: "label-chip"
                                            },
                                            label: activityTypeText,
                                            color: "primary",
                                            size: "small"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                            style: {
                                                cursor: (activity === null || activity === void 0 ? void 0 : (ref3 = activity.manager) === null || ref3 === void 0 ? void 0 : ref3.channel) === undefined || (activity === null || activity === void 0 ? void 0 : (ref4 = activity.manager) === null || ref4 === void 0 ? void 0 : ref4.channel) === null ? "default" : "pointer"
                                            },
                                            className: "company-name",
                                            onClick: handleClickOrganization,
                                            children: activity === null || activity === void 0 ? void 0 : activity.organizationName
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                mr: 3.75,
                                flexGrow: 1,
                                width: "100%",
                                mb: 0.5,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_Link__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)({
                                    className: "link"
                                }, (activity === null || activity === void 0 ? void 0 : activity.id) ? {
                                    href: "/activity/[id]",
                                    as: "/activity/".concat(activity === null || activity === void 0 ? void 0 : activity.id)
                                } : {
                                    href: ""
                                }), {
                                    naked: true
                                }), linkProps), {
                                    children: isLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_app_components_Skeleton__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                        height: 13
                                    }) : isRecommend ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        className: "container",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                className: "recommend-tag-container",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                    className: "recommend-text",
                                                    children: "추천"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                className: "title",
                                                dangerouslySetInnerHTML: {
                                                    __html: highlightedTitle
                                                }
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                        className: "title",
                                        dangerouslySetInnerHTML: {
                                            __html: highlightedTitle
                                        }
                                    })
                                }))
                            }),
                            (props === null || props === void 0 ? void 0 : (ref5 = props.renderSecondary) === null || ref5 === void 0 ? void 0 : ref5.call(props)) || renderSecondary()
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                        flexShrink: 0,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_ActivityScrap__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                            activity: activity,
                            currentUser: currentUser,
                            refetchQueries: scrapRefetchQueries,
                            children: function(param) {
                                var scrapActivity = param.scrapActivity, loading = param.loading, scrapCount = param.scrapCount;
                                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z, {
                                            onClick: scrapActivity,
                                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)("button-scrap", {
                                                scrapped: activity === null || activity === void 0 ? void 0 : activity.isScrapped
                                            }),
                                            disabled: loading,
                                            children: !loading ? scrapIcon : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core_CircularProgress__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z, {
                                                size: 18
                                            })
                                        }),
                                        showScrapCount && (isLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_app_components_Skeleton__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                            width: 20,
                                            className: "scrap-count-skeleton",
                                            height: 13
                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                            color: "textSecondary",
                                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)("scrap-count", {
                                                scrapped: activity === null || activity === void 0 ? void 0 : activity.isScrapped
                                            }),
                                            children: scrapCount
                                        }))
                                    ]
                                });
                            }
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ActivityListItem);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_29__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "ActivityListItem__StyledWrapper",
    componentId: "sc-ae05ad57-0"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_29__/* .css */ .iv)(_templateObject1(), theme.breakpoints.up("md"), theme.breakpoints.down("sm"), theme.line.line_3, theme.color.primary_2, theme.color.text_3, theme.color.primary_2, theme.color.secondary_1, theme.color.secondary_1);
});


/***/ }),

/***/ 53518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_Chip__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(16204);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75154);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(86010);
/* harmony import */ var svgIcons_Close__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43785);







var useStyles = (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
    return (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        root: {
            borderRadius: 5,
            height: 52,
            fontSize: 15
        },
        labelSmall: {
            paddingLeft: 15,
            paddingRight: 15
        },
        colorPrimary: {
            color: "#333333",
            backgroundColor: "#f2faff",
            border: "1px solid #d9e9f3"
        },
        clickable: {
            "&:active": {
                boxShadow: "none"
            }
        },
        clickableColorPrimary: {
            "&:hover, &:focus": {
                backgroundColor: "#f2faff"
            }
        },
        deletableColorPrimary: {
            "&:focus": {
                backgroundColor: "#f2faff"
            }
        },
        deleteIcon: {
            marginRight: 15,
            marginLeft: 5
        },
        deleteIconColorPrimary: {
            color: "#333333",
            width: 10,
            height: 10,
            marginRight: 15,
            marginLeft: 5,
            "&:hover": {
                color: "#000000"
            }
        },
        sizeSmall: {
            height: 39,
            fontSize: 12
        }
    });
});
function ChipDeleteIcon(_param) {
    var onClick = _param.onClick, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "onClick"
    ]);
    // https://benfrain.com/converting-divs-into-accessible-pseudo-buttons/
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        role: "button",
        "aria-pressed": "false",
        tabIndex: 0,
        onClick: onClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(svgIcons_Close__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props))
    });
}
var OldChip = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var classes = useStyles();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Chip__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        classes: {
            root: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(classes.root, props === null || props === void 0 ? void 0 : (ref = props.classes) === null || ref === void 0 ? void 0 : ref.root),
            labelSmall: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(classes.labelSmall, props === null || props === void 0 ? void 0 : (ref1 = props.classes) === null || ref1 === void 0 ? void 0 : ref1.labelSmall),
            colorPrimary: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(classes.colorPrimary, props === null || props === void 0 ? void 0 : (ref2 = props.classes) === null || ref2 === void 0 ? void 0 : ref2.colorPrimary),
            clickable: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(classes.clickable, props === null || props === void 0 ? void 0 : (ref3 = props.classes) === null || ref3 === void 0 ? void 0 : ref3.clickable),
            clickableColorPrimary: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(classes.clickableColorPrimary, props === null || props === void 0 ? void 0 : (ref4 = props.classes) === null || ref4 === void 0 ? void 0 : ref4.clickableColorPrimary),
            deletableColorPrimary: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(classes.deletableColorPrimary, props === null || props === void 0 ? void 0 : (ref5 = props.classes) === null || ref5 === void 0 ? void 0 : ref5.deletableColorPrimary),
            deleteIcon: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(classes.deleteIcon, props === null || props === void 0 ? void 0 : (ref6 = props.classes) === null || ref6 === void 0 ? void 0 : ref6.deleteIcon),
            deleteIconColorPrimary: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(classes.deleteIconColorPrimary, props === null || props === void 0 ? void 0 : (ref7 = props.classes) === null || ref7 === void 0 ? void 0 : ref7.deleteIconColorPrimary),
            sizeSmall: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(classes.sizeSmall, props === null || props === void 0 ? void 0 : (ref8 = props.classes) === null || ref8 === void 0 ? void 0 : ref8.sizeSmall)
        },
        deleteIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ChipDeleteIcon, {})
    }, props));
};
/* harmony default export */ __webpack_exports__["Z"] = (OldChip);


/***/ }),

/***/ 17683:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var keyword_highlighter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72423);
/* harmony import */ var keyword_highlighter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(keyword_highlighter__WEBPACK_IMPORTED_MODULE_1__);

// @ts-ignore

function useKeywordHighlighter(props) {
    var text = props.text, _keyword = props.keyword, keyword = _keyword === void 0 ? "" : _keyword;
    var highlightedText = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return keyword_highlighter__WEBPACK_IMPORTED_MODULE_1___default()(keyword, text);
    }, [
        text,
        keyword
    ]);
    return keyword ? highlightedText : text;
}
/* harmony default export */ __webpack_exports__["Z"] = (useKeywordHighlighter);


/***/ })

}]);